module.exports = __webpack_public_path__ + "img/keia.9caefe46.png";